import Breadcrumb from "../Breadcrumb";

export default function PageHeader({ routeSegments, subtitle, actions }) {
  return <div className="gull-page-header">
    <div className="gull-page-heading">
      <Breadcrumb routeSegments={routeSegments} />
      {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
    </div>
    {actions && <div className="gull-page-header-actions">{actions}</div>}
  </div>;
}
